import { useCallback } from 'react';
import { useModal } from '@grnhse/seedling/lib/birch/components/modals';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';

type Params = {
  isDirty: boolean;
  onClose: () => void;
  setValue: ReturnType<typeof useFormContext>['setValue'];
  clearErrors: ReturnType<typeof useFormContext>['clearErrors'];
  setActiveTab: (tab: 'current' | 'history') => void;
  userPromptMode: string;
};

export const useExitWithoutSaving = ({
  isDirty,
  onClose,
  setValue,
  clearErrors,
  setActiveTab,
  userPromptMode,
}: Params) => {
  const [
    isExitWithoutSavingModalOpen,
    openExitWithoutSavingModal,
    closeExitWithoutSavingModal,
  ] = useModal();

  const closeAndReset = useCallback(() => {
    closeExitWithoutSavingModal();
    if (userPromptMode !== 'initial') {
      setValue('userPromptMode', 'view');
    }
    clearErrors('root.parseSkills');
    clearErrors('root.suggestedSkills');
    setActiveTab('current');
    onClose();
  }, [
    clearErrors,
    closeExitWithoutSavingModal,
    onClose,
    setActiveTab,
    setValue,
    userPromptMode,
  ]);

  const handleOnClose = useCallback(() => {
    if (isDirty) {
      openExitWithoutSavingModal();
      return;
    }
    closeAndReset();
  }, [closeAndReset, isDirty, openExitWithoutSavingModal]);

  return {
    isExitWithoutSavingModalOpen,
    handleOnClose,
    closeExitWithoutSavingModal,
    closeAndReset,
  };
};
